import React from 'react';
import PropTypes from 'prop-types';

const BetSlipOddsWsUpdate = ({
  prevOdd,
  odd,
}) => {

  return (
    <div className="betslip-row__odd-change-row animated fadeInUp faster">
      <span className="betslip-row__odd-change-row--odd-text"> <b>Oran değişti!</b>  </span>
      <span> Eski oran: { prevOdd } </span>
      <span> Yeni oran: { odd } </span>
    </div>
  );
};

BetSlipOddsWsUpdate.propTypes = {
  prevOdd: PropTypes.string,
  odd: PropTypes.string
};

export default BetSlipOddsWsUpdate;
